import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProviderItem } from '~/models/Comons';
import { RootState } from '~/store/index';

interface State {
    cloudProviderName: ProviderItem[];
}

const initialState: State = {
    cloudProviderName: [],
};

const ProviderSlice = createSlice({
    name: 'provider',
    initialState,
    reducers: {
        SET_PROVIDERS(state, { payload }: PayloadAction<ProviderItem[]>) {
            state.cloudProviderName = payload;
        },
    },
});

export const selectProvider = (state: RootState) => state.provider;

export const { SET_PROVIDERS } = ProviderSlice.actions;

export default ProviderSlice.reducer;
